import saveAs from "file-saver"
import config from "../config"

// `S3_URL` stays editor-side: it is env-config-driven (per-environment bucket).
// The editor passes it explicitly into the shared lib exporter (the `FileProcessor`
// subclass in fileProcessor.helpers.ts supplies it as the `s3Url` constructor arg).
// `S3_PREFIX` and the browser-I/O helpers below are editor-only concerns.
export const S3_URL = `https://s3.${config.awsRegion}.amazonaws.com/${config.bucket}`
export const S3_PREFIX = "public"

//-----------------------------
//download file when content is string, (example fileContent = html, fileName = index.html)
//-----------------------------
export const fileDownload = (fileName: string, fileContent: string) => {
    const blob = new Blob([fileContent], { type: "text/plain;charset=utf-8" })
    saveAs(blob, fileName)
}

//--------------------------------
//convert File to base64 as string
//--------------------------------
export const fileToBase64 = (file: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.readAsDataURL(file)

        fileReader.onload = () => {
            resolve(fileReader.result as string)
        }

        fileReader.onerror = (error) => {
            reject(error)
        }
    })
}

interface ImageMetadata {
    width: number
    height: number
}

export const getImageMetadata = (blob: Blob): Promise<ImageMetadata> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
            const img = new Image()
            img.onload = () => {
                resolve({ width: img.naturalWidth, height: img.naturalHeight })
            }
            img.onerror = reject

            img.src = reader.result as string
        }
        reader.onerror = reject

        reader.readAsDataURL(blob)
    })
}

export const readFile = (file: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.onload = () => {
            resolve(fileReader.result as string)
        }
        fileReader.onerror = (error) => {
            reject(error)
        }
        fileReader.readAsText(file)
    })
}

// Get <meta> of HTML with property equals to "metaName" and return its "content"
export const getMetaTag = (file: any, metaName: string): string => {
    const toNodes = (html: string) => new DOMParser().parseFromString(html, "text/html")
    const metas = toNodes(file).getElementsByTagName("meta")

    let result: string = ""

    for (let i = 0; i < metas.length; i++) {
        // looking for meta's property, which is equals to metaName
        if (metas[i].getAttribute("property") === metaName) {
            result = metas[i].getAttribute("content") ?? ""
        }
    }
    return result
}
